import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex overflow-hidden',
    container: 'w-full',
    titleProduct:
      'md:heading-s-bold heading-xs-bold cursor-pointer rounded-full bg-white p-3 md:px-4 md:py-2',
    titleSection:
      'heading-2xl absolute top-8 z-2 container max-sm:max-w-100 lg:inset-x-0 lg:top-10 lg:m-auto lg:mb-5 lg:text-[40px]',
    top: 'absolute top-29 right-0 left-0 z-2 container mb-5 flex flex-wrap gap-2 sm:top-21 lg:top-27 lg:right-0 lg:left-0 lg:m-auto lg:gap-7',
    carousel: 'w-screen [--slide-size:100%]',
    iconTop: 'absolute right-0 hidden lg:-right-5 lg:flex',
    itemTop: 'relative flex items-center lg:last:overflow-hidden',
    banner:
      'md:flex-center h-240 w-full sm:h-235 md:relative md:h-240 md:flex-col lg:h-175 2xl:aspect-[1440/700] 2xl:max-h-240',
    bgImageWrapper:
      'absolute size-full max-lg:top-20 max-lg:h-125 max-md:h-110 max-sm:top-36',
    bgImage: 'absolute inset-0 object-cover',
    arrowPrev:
      'top-[370px] right-auto -bottom-5 left-3 z-3 flex size-12 rounded-full bg-white lg:top-1/2 lg:-translate-y-1/2',
    arrowNext:
      'top-[370px] right-3 -bottom-5 left-auto z-3 flex size-12 rounded-full bg-white lg:top-1/2 lg:-translate-y-1/2',
    body: 'relative'
  },
  variants: {
    activeItem: {
      true: {
        titleProduct:
          'bg-[linear-gradient(101.25deg,#DAE8FF_-0.09%,#E6F9FF_65.89%)]'
      }
    },
    mode: {
      pink: {
        titleSection: 'text-black',
        banner: 'bg-[linear-gradient(179.99deg,#FAF9FE_0.01%,#EEF2FB_72.53%)]'
      },
      dark: {
        banner:
          'bg-[linear-gradient(6.09deg,#0C0F20_33.77%,#4F5575_80.27%,#2C314E_85.84%)]',
        bgImageWrapper: 'max-md:h-114 max-sm:top-36',
        titleSection: 'text-white'
      },
      light: {
        banner: 'bg-[linear-gradient(350.27deg,#CCD5DE_33.3%,#C6D0DA_86.96%)]',
        titleSection: 'text-white'
      }
    }
  }
});

// background: linear-gradient(350.27deg, #CCD5DE 33.3%, #C6D0DA 86.96%);
